export const isNetworkErrorResponse = error => {
  var _networkError;
  return Boolean(error && error.networkError && ((_networkError = error.networkError) === null || _networkError === void 0 ? void 0 : _networkError.responseJSON));
};